
class $52dac2d1d1983268$export$cfc7921d29ef7b80 {
    constructor(name, action){
        this.name = name;
        this.action = action;
    }
}


class $58c62d07c237f63d$export$9e37f1921390352d {
    constructor(name, buttons){
        this.name = name;
        this.buttons = buttons;
    }
}


class $28770b279d7ab5b1$export$d2ca453b913dcdea {
    static doOnLines(text, process) {
        return process(text.split("\n")).join("\n");
    }
    static wrapInDivWithClassList(element, classList) {
        let div = document.createElement("div");
        classList.forEach((klass)=>{
            div.classList.add(klass);
        });
        div.append(element);
        return div;
    }
}


const $35467e556c78cf4f$export$5b26fc7e638ec99f = new (0, $58c62d07c237f63d$export$9e37f1921390352d)("Filter", [
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("Remove duplicates", function(input) {
        return (0, $28770b279d7ab5b1$export$d2ca453b913dcdea).doOnLines(input, (lines)=>{
            return lines.filter((value, index, self)=>index === self.findIndex((t)=>t === value));
        });
    }),
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("Remove empty lines", function(input) {
        return (0, $28770b279d7ab5b1$export$d2ca453b913dcdea).doOnLines(input, (lines)=>{
            return lines.filter((value, index, self)=>value && !/^\s*$/.test(value));
        });
    })
]);




const $877cd07df912b182$export$196d83b81c2c23a4 = new (0, $58c62d07c237f63d$export$9e37f1921390352d)("Format", [
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("UPPERCASE", function(input) {
        return input.toUpperCase();
    }),
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("lowercase", function(input) {
        return input.toLowerCase();
    }),
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("Decode URL", function(input) {
        return decodeURI(input);
    }),
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("Encode URL", function(input) {
        return encodeURI(input);
    }),
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("Text to branch name", function(input) {
        return input.replace(/ /g, "-").replace(/"/g, "").replace(/[-]+/g, "-");
    })
]);




const $13b9c4e2535e57d5$export$555f3e6e077a8789 = new (0, $58c62d07c237f63d$export$9e37f1921390352d)("Sort", [
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("By name", function(input) {
        return input?.split("\n").sort().join("\n");
    }),
    new (0, $52dac2d1d1983268$export$cfc7921d29ef7b80)("By length", function(input) {
        return input?.split("\n").sort(function(a, b) {
            return a.length - b.length;
        }).join("\n");
    })
]);



const $b4e14b6b8da86996$var$sections = [
    (0, $13b9c4e2535e57d5$export$555f3e6e077a8789),
    (0, $35467e556c78cf4f$export$5b26fc7e638ec99f),
    (0, $877cd07df912b182$export$196d83b81c2c23a4)
];
const $b4e14b6b8da86996$var$toolsColumns = document.getElementById("tools");
const $b4e14b6b8da86996$var$textArea = document.getElementById("inputText");
const $b4e14b6b8da86996$var$searchField = document.getElementById("searchField");
$b4e14b6b8da86996$var$searchField?.addEventListener("input", (event)=>$b4e14b6b8da86996$var$loadSections());
function $b4e14b6b8da86996$var$loadSections() {
    $b4e14b6b8da86996$var$toolsColumns?.replaceChildren();
    $b4e14b6b8da86996$var$sections.forEach((section)=>{
        const title = document.createElement("h2");
        title.innerText = section.name;
        title.classList.add("subtitle", "mb-2");
        let column = $b4e14b6b8da86996$var$toolsColumns?.appendChild((0, $28770b279d7ab5b1$export$d2ca453b913dcdea).wrapInDivWithClassList(title, [
            "column"
        ]));
        section.buttons.filter((value, index, self)=>value.name.toLowerCase().includes($b4e14b6b8da86996$var$searchField?.value.toLowerCase() ?? "")).forEach((actionButton)=>{
            const button = document.createElement("button");
            button.innerText = actionButton.name;
            button.classList.add("button", "is-rounded", "mb-2");
            button.addEventListener("click", function handleClick() {
                if ($b4e14b6b8da86996$var$textArea == null) return;
                const text = $b4e14b6b8da86996$var$textArea.value;
                $b4e14b6b8da86996$var$textArea.value = actionButton.action(text);
            });
            const div = document.createElement("div");
            div.appendChild(button);
            column?.appendChild(div);
        });
    });
}
$b4e14b6b8da86996$var$loadSections();


//# sourceMappingURL=index.6e50356e.js.map
